import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { EventLoggerService } from '@services/event-logger-service';
import { ApiClientConstant } from '@cureskin/api-client/src/constant/api-client.constant';
import { FOLLOWUP_NUDGE_TYPE, FollowUpNudgeBottomSheetData } from '@services/regimen-reorder-service/regimen-reorder.types';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 'followup-nudge-bottomsheet',
  standalone: true,
  imports: [ButtonCtaComponent, DatePipe],
  templateUrl: './followup-nudge-bottomsheet.component.html',
})
export class FollowUpNudgeBottomsheetComponent {

  readonly data: FollowUpNudgeBottomSheetData = inject(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef<FollowUpNudgeBottomsheetComponent>);
  private readonly eventLoggerService = inject(EventLoggerService);
  private readonly router = inject(Router);
  private readonly connectionService = inject(ConnectionService);
  readonly ApiClientConstant = ApiClientConstant
  readonly FOLLOWUP_NUDGE_TYPE = FOLLOWUP_NUDGE_TYPE;

  takeCheckupLoading: boolean = false;

  get kitImage(): string {
    return this.data.regimenClass === ApiClientConstant.Regimen.Class.HAIR
      ? 'https://cdn.cureskin.com/app/img/dr_holding_purple_kit_with_background.png'
      : 'https://cdn.cureskin.com/app/img/dr_holding_orange_kit_with_background.png';
  }

  get formattedLastUpdatedAt(): Date | null {
    return this.data.lastUpdatedAt ? new Date(this.data.lastUpdatedAt) : null;
  }

  get formattedFollowUpDate(): Date | null {
    return this.data.followUpDate ? new Date(this.data.followUpDate) : null;
  }

  async takeCheckup(): Promise<void> {
    this.takeCheckupLoading = true;
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({
      name: 'followup_nudge_take_checkup',
      type: this.data.type,
    }));
    const response = await this.connectionService.createFollowUp();
    const followUpId = response?.followUpId || this.data.followUpId;
    this.takeCheckupLoading = false;
    this.bottomSheetRef.dismiss();
    this.router.navigate([`/chatV2/${followUpId}`], { queryParams: { type: 'followUp' } });
  }

  orderWithoutUpdating(): void {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({
      name: 'followup_nudge_order_without_updating',
      type: this.data.type,
    }));
    this.bottomSheetRef.dismiss({ proceedToCheckout: true });
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
